// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { memo, useRef, useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Switch from 'react-switch'
import classnames from 'classnames'
import './NewAlertForm.scss'
import { TextEditor, CharacterLimitCounter, SecondaryButton, PrimaryButton } from 'ui_kit_qmd'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { addAlert } from '../../../../store/charts/ChartsThunk'
import {
  ALERT_MESSAGE_TEXT,
  EDIT_ALERT_TEXT,
  INTAKE_FORMS_CANCEL_BTN_TEXT,
  INTAKE_FORMS_CREATE_QUESTION_SAVE_BTN_LABEL_TEXT,
  NEW_ALERT_TEXT,
  NO_TEXT,
  TYPE_SOMETHING_TEXT,
  VISIBLE_TO_ALL_TEXT,
  YES_TEXT,
} from '../../../../utils/constants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../utils/errormessages'
import { setChartsError } from '../../../../store/charts/ChartsActions'
import { NewAlertSwitchStatus } from '../new-alert-switch-status/NewAlertSwitchStatus'

const switchOffColor = '#B0BDCB'
const switchOnColor = '#00A2B2'
const switchActiveBoxShadow = '#ffffff'
const switchHeight = 30
const switchWidth = 76

const buttonContainerStyle = {
  width: 104,
  height: 40,
}

const cancelButtonContainerStyle = {
  marginRight: 16,
}

const saveButtonLabelStyle = {
  color: '#ffffff',
  fontWeight: 700,
  fontSize: 20,
}

const MAX_NEW_ALERT_CHARACTER_LIMIT = 5000

export const NewAlertForm = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    onCloseAction,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    newAlertValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setNewAlertValue,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isVisibleToAll,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsVisibleToAll,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editAlertId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className = '',
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    addAlertCallback,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editAlertCallback,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isSideCollapsed,
  }) => {
    const { search } = useLocation()
    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const params = new URLSearchParams(search)
    const alertValueRef = useRef()
    const dispatch = useDispatch()

    // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
    const [editAlertValue, setEditAlertValue] = useState('')
    const [newAlertInputError, setNewAlertInputError] = useState('')

    useEffect(() => {
      if (newAlertValue) {
        setEditAlertValue(newAlertValue)
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        alertValueRef?.current?.onSetValue(newAlertValue)
      }
      setNewAlertInputError('')
    }, [])

    useEffect(() => {
      setNewAlertInputError('')
    }, [newAlertValue])

    const onChangeSwitch = () => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setIsVisibleToAll((prev) => !prev)
    }

    const onClickCancelButton = () => {
      setNewAlertValue('')
      setIsVisibleToAll(true)
      onCloseAction()
    }

    const onClickSave = () => {
      const message = newAlertValue.replace(/(\r\n|\r|\n){3,}/g, '$1\n')

      if (!message.replaceAll('\n', '').trim()) {
        setNewAlertInputError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, ALERT_MESSAGE_TEXT))
        dispatch(setChartsError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
        return
      }

      if (newAlertValue.length > MAX_NEW_ALERT_CHARACTER_LIMIT) {
        setNewAlertInputError(getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT))
        dispatch(setChartsError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
        return
      }

      if (!editAlertId) {
        addAlertCallback({ Message: newAlertValue, IsPrivate: !isVisibleToAll })
      } else {
        editAlertCallback({ alertId: editAlertId, Message: newAlertValue, IsPrivate: !isVisibleToAll })
      }
    }

    return (
      <div
        className={classnames('new-alert-form-main-wrapper', {
          [className]: className,
          'collapsed-side-panel': isSideCollapsed,
        })}>
        <div className='new-alert-form-header'>
          <div className='new-aler-form-title'>{editAlertId ? EDIT_ALERT_TEXT : NEW_ALERT_TEXT}</div>
          <div className='new-alert-form-all-visible-wrapper'>
            <div className='new-alert-form-all-visible-text'>{VISIBLE_TO_ALL_TEXT}</div>
            <Switch
              onChange={onChangeSwitch}
              checked={isVisibleToAll}
              offColor={switchOffColor}
              onColor={switchOnColor}
              height={switchHeight}
              width={switchWidth}
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              uncheckedIcon={<NewAlertSwitchStatus statusValue={NO_TEXT} />}
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              checkedIcon={<NewAlertSwitchStatus statusValue={YES_TEXT} />}
              activeBoxShadow={switchActiveBoxShadow}
            />
          </div>
        </div>
        <div className='new-alert-form-text-area-wrapper'>
          <TextEditor
            placeHolderText={TYPE_SOMETHING_TEXT}
            id='newAlertInput'
            isError={!!newAlertInputError}
            setText={setNewAlertValue}
            ref={alertValueRef}
            descriptionLocalError={newAlertInputError}
          />
          <CharacterLimitCounter
            currentAmount={newAlertValue.length}
            limit={MAX_NEW_ALERT_CHARACTER_LIMIT}
            isHighlightError={newAlertValue.length > MAX_NEW_ALERT_CHARACTER_LIMIT}
          />
        </div>
        <div className='new-alert-form-buttons-wrapper'>
          <SecondaryButton
            id='new-alert-form-close-button'
            btnText={INTAKE_FORMS_CANCEL_BTN_TEXT}
            onPress={onClickCancelButton}
            containerStyle={{ ...buttonContainerStyle, ...cancelButtonContainerStyle }}
          />
          <PrimaryButton
            id='new-alert-form-save-button'
            btnText={INTAKE_FORMS_CREATE_QUESTION_SAVE_BTN_LABEL_TEXT}
            onPress={onClickSave}
            labelStyle={saveButtonLabelStyle}
            containerStyle={buttonContainerStyle}
          />
        </div>
      </div>
    )
  },
)
